<template>
    <div id="spices" class="tab-pane">
        <p class="help-block">
            <span class="db"
                >Obs! Lägg endast till kryddor från denna flik då näringsvärden och kalorier inte kommer
                registreras.</span
            >
        </p>
        <table>
            <thead>
                <tr>
                    <th class="quantity-col">Mängd</th>
                    <th class="unit-col">Enhet</th>
                    <th class="ingredient-col">Krydda</th>
                    <th class="delete-col"></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="quantity-col">
                        <div class="form-group">
                            <input
                                type="number"
                                class="form-control quantity"
                                min="0"
                                step="0.5"
                                v-model="qty"
                            />
                        </div>
                    </td>
                    <td class="unit-col">
                        <div class="form-group">
                            <input
                                type="text"
                                class="form-control unit"
                                placeholder="Ange enhet"
                                v-model="unit"
                            />
                        </div>
                    </td>
                    <td class="ingredient-col">
                        <div class="form-group">
                            <input
                                type="text"
                                class="form-control"
                                name="ingredient"
                                placeholder="Ange ingrediens"
                                v-model="title"
                            />
                        </div>
                    </td>
                    <td class="add-ingredient-col actions">
                        <div class="form-group">
                            <svg id="add-ingredient" class="icon add-ingredient" @click="addIngredient">
                                <use xlink:href="#icon-plus"></use>
                            </svg>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import state from './../state.js';

export default {
    data() {
        return {
            state,
            qty: 1,
            unit: 'Ange enhet',
            title: ''
        };
    },

    methods: {
        addIngredient() {
            const addIngredient = {
                quantity: this.qty,
                unit: this.unit,
                ingredient: this.title
            };

            if (this.title && this.unit) {
                this.state.recipeIngredients.unshift(addIngredient);
                this.title = '';
                this.unit = '';
            } else {
                this.state.prompt = 'Ange enhet och ingrediens.';
            }
        }
    }
};
</script>
